import React from 'react';

export default function StatusBadge({ inArrears, arrearsDays, arrearsAmount }) {
  if (!inArrears) {
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-brand-100 text-brand-700">
        <span className="w-1.5 h-1.5 rounded-full bg-brand-500 inline-block"></span>
        Up to date
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
      <span className="w-1.5 h-1.5 rounded-full bg-amber-500 inline-block"></span>
      {arrearsDays} day{arrearsDays !== 1 ? 's' : ''} overdue
    </span>
  );
}
